import React from "react";

const Chapter8 = () => {
  return (
    <>
      <h2>
        Does storm runoff from urban areas influence the amount of nutrients in
        our lakes and rivers?
      </h2>
      <p>
        Phosphorus and nitrate are often present in storm runoff from urban
        areas. A recent CDPHE study of nutrient contributions from municipal
        storm sewers indicated that while nutrients are present in storm runoff,
        it is not a major source.
      </p>
      <p>
        When heavy rain falls or snow melts, that water moves over and through
        the ground taking with it natural and human-made pollutants. In urban
        areas, this water cannot soak into the ground so it flows over
        impervious surfaces like streets and moves quickly into nearby lakes or
        rivers. Urban storm runoff can mobilize contaminants like fecal matter
        (a source of nitrate) that have accumulated on urban landscapes,
        transporting those contaminants into nearby waters.{" "}
      </p>
      <p>
        Phosphorus gets into water in both urban and agricultural settings.
        Phosphorus is a common constituent of organic wastes in sewage and
        industrial effluent, fertilizers, and manure (including pet waste). Soil
        erosion is also major contributor of phosphorus to streams. Phosphorus
        tends to attach to soil particles and moves into surface-water bodies
        when there is runoff. Bank erosion occurring during floods can transport
        phosphorous from the river banks and adjacent land into a stream.{" "}
      </p>
    </>
  );
};

export default Chapter8;
